import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {SponsorPage} from "../sponsor/SponsorPage";
import {ADVERTISE_PATH} from "../sponsor/sponsorRoutes";

/**
 * Public, pre-rendered self-serve advertising booking page (`/advertise`, ui#496; renamed from
 * `/sponsor` on 2026-08-17 with the rest of the buyer-facing wording).
 *
 * Thin wrapper (mirrors {@link ./PricingRoute.tsx}): `<Seo>` plus the page. The canonical URL is
 * derived from `path` per active locale by `<Seo>`, so the `/ro` mirror needs no separate wiring —
 * and it points at the NEW path, so the legacy `/sponsor` redirect shell cannot claim a canonical.
 *
 * Indexable on purpose. It is now reached from {@link ./AdvertisingRoute.tsx}, which is what the
 * Resources menu and the sitemap point at, rather than being the first thing a stranger meets.
 */
export function Component() {
	const {sponsor} = useMessages();
	return (
		<>
			<Seo title={sponsor.seo.title} description={sponsor.seo.description} path={ADVERTISE_PATH}/>
			<SponsorPage/>
		</>
	);
}
